/**
 * Web implementation for Firebase Analytics
 * This provides a mock implementation that completely disables analytics on web
 */

const logEvent = (_eventName: string, _params?: Record<string, any>) => {
  // No-op implementation
  return Promise.resolve();
};

const logScreenView = (_screen: string, _screenClass?: string) => {
  // No-op implementation
  return Promise.resolve();
};

const setUserId = (_id: string | null) => {
  // No-op implementation
  return Promise.resolve();
};

const setUserProperties = (_properties: Record<string, string | null>) => {
  // No-op implementation
  return Promise.resolve();
};

export default {
  logEvent,
  logScreenView,
  setUserId,
  setUserProperties,
};
